"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrCatalogsCard = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const fdr_lib_misc_catalogs_1 = require("@hotelplan/fdr.lib.misc.catalogs");
const fdr_lib_track_catalog_1 = require("@hotelplan/fdr.lib.track.catalog");
const fdr_catalogs_card_styles_1 = require("./fdr-catalogs-card.styles");
const FdrCatalogsCard = ({ ordered, onOrder, image, link, downloadLink, onlineOrderAvailable, type, id, position, from, to, cardConfig, }) => {
    const [t, { language }] = (0, next_i18next_1.useTranslation)('catalogs');
    const track = (0, fdr_lib_track_catalog_1.trackCatalog)({ type, id }, position);
    const { orderComponent: OrderComponent } = cardConfig;
    return (react_1.default.createElement(fdr_catalogs_card_styles_1.CatalogsListWrap, { "data-id": `${type}_${id}` },
        react_1.default.createElement(fdr_regular_basis_fdr_route_1.FdrRoute, { link: {
                type: supergraph_api_1.FdrLinkType.External,
                url: link,
                openMethod: supergraph_api_1.FdrLinkOpenMethod.NewTab,
            }, className: "imageWrap" },
            react_1.default.createElement(fdr_regular_basis_fdr_image_1.FdrImage, { className: "catalogs-link-image", image: image, testId: "card-image", onClick: track.view })),
        react_1.default.createElement("div", { className: "content" },
            cardConfig.showValidityDates && (react_1.default.createElement("div", { className: "validity-dates" },
                react_1.default.createElement("strong", null, t('catalogs:validity.title')),
                react_1.default.createElement("p", null, t('catalogs:validity.period', {
                    from: (0, fdr_lib_misc_catalogs_1.formatToCatalogsDate)(from, language),
                    to: (0, fdr_lib_misc_catalogs_1.formatToCatalogsDate)(to, language),
                })))),
            react_1.default.createElement("div", { className: "catalog-links" },
                react_1.default.createElement("div", { className: "link-wrapper" },
                    react_1.default.createElement(fdr_regular_basis_fdr_route_1.FdrRoute, { link: {
                            type: supergraph_api_1.FdrLinkType.External,
                            url: downloadLink,
                            openMethod: supergraph_api_1.FdrLinkOpenMethod.NewTab,
                        } },
                        react_1.default.createElement(fdr_catalogs_card_styles_1.CatalogDownloadButton, { onClick: track.download }, t('catalogs:downloadPdf')))),
                cardConfig.showViewOnlineButton && (react_1.default.createElement("div", { className: "link-wrapper" },
                    react_1.default.createElement(fdr_regular_basis_fdr_route_1.FdrRoute, { link: {
                            type: supergraph_api_1.FdrLinkType.External,
                            url: link,
                            openMethod: supergraph_api_1.FdrLinkOpenMethod.NewTab,
                        } },
                        react_1.default.createElement(core_basis_bs_button_1.BsButton, { onClick: track.view }, t('catalogs:viewOnline')))))),
            onlineOrderAvailable && (react_1.default.createElement(OrderComponent, { ordered: ordered, onOrder: onOrder })))));
};
exports.FdrCatalogsCard = FdrCatalogsCard;
//# sourceMappingURL=fdr-catalogs-card.js.map